import Vue from "vue";
import { getField, updateField } from "vuex-map-fields";
import router from "../../../router";
import CRCModule from "@/qr/CrcCitt.js";
import napasQR from "../../../qr/NapasQR";
import MMQR from "@/qr/MMQR.js";

const qrValidationResult = (step = "", isValid, qrHashMap = null) => ({ step, isValid, qrHashMap });

// QR 단계별 검증 방법
const qrValidation = [

  // Step 1 : BASIC 검증
  (basic) => {
    return qrValidationResult(Vue.prototype.$config.QR_VALIDATION_BASIC, !basic ? false : true, null);
  },

  // Step 2 : CRC 검증
  (crc, operGroupCd) => {
    return qrValidationResult(Vue.prototype.$config.QR_VALIDATION_CRC, CRCModule.validateCRC(crc, operGroupCd) ? true : false, null);
  },

  // Step 3 : Business 검증
  (business, operGroupCd) => {

    var qrHashMap = {};

    // QR 파싱
    if (operGroupCd.includes("VN")) {
      var napasQRInstance = new napasQR();
      qrHashMap = napasQRInstance.convertQRStringtoKV(business);
    } else if (operGroupCd.includes("MM")) {
      var mmQRInstance = new MMQR();
      var mmQRItem = mmQRInstance.QRtoValue(business);
      qrHashMap = mmQRInstance.getMMQRHashMap(mmQRItem);
    }

    if (!qrHashMap) {
      return qrValidationResult(Vue.prototype.$config.QR_VALIDATION_BUSINESS, false, null);
    } else {
      return qrValidationResult(Vue.prototype.$config.QR_VALIDATION_BUSINESS, true, qrHashMap);
    }
  }
];

// QR 검증 진행
const validateQR = (qrData, operGroupCd) => {

  var qrHashMap = {};

  for (const validation of qrValidation) {

    const result = validation(qrData, operGroupCd);

    if (!result.isValid) {
      return result;
    }
    if (result.step == Vue.prototype.$config.QR_VALIDATION_BUSINESS && result.isValid) {
      qrHashMap = result.qrHashMap;
    }
  }
  return qrValidationResult(Vue.prototype.$config.QR_VALIDATION_SUCCESS, true, qrHashMap);
}

const getDefaultState = () => {
  return {
    napasQrHashMap: {},
    mmQRHashMap: {},
    qrString: "",
    qrInfo: {},
  };
};
const qrPaymentInpt = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getField,
  },
  mutations: {
    updateField,
    resetState: state => {
      Object.assign(state, getDefaultState());
    },

    setRouterInfo(state, payload) {
      console.log("state : " + state + "/" + " payload : " + payload);
      payload.type = "qrscan"; // qrscan으로부터 온 경우
      router.app.$router.push({ name: "myQr", params: payload });
    },
    qrUnderApprovalInfo(state, payload) {
      payload.type = "qrscan"; // qrscan으로부터 온 경우
      payload.svcDstcd = "0"; // QR Payment -> 서비스구분코드: 0
      // router.app.$router.push({ name: "qrUnderApproval", params: payload });
      router.app.$router.push({ name: "paymentHistory1", params: payload });
    },
    setQrInfo_init: state => {
      state.napasQrHashMap = getDefaultState().napasQrHashMap;
      state.qrString = getDefaultState().qrString;
      state.qrInfo = getDefaultState().qrInfo;
    },
    setMMQRHashMap(state, payload) {
      state.mmQRHashMap = payload;
    },
    setQRString(state, payload) {
      state.qrString = payload;
    },
  },
  actions: {
    ACT_setQrInfo_init: context => {
      context.commit("setQrInfo_init");
    },
    // qr 인증
    setQrInfo: function (context, payload) {

      context.state.qrInfo = payload;
      var operGroupCd = this.state.common.main.operGroupCd || Vue.prototype.$config.OPER_GROUP_CD_OGHCM;

      // 네이티브 검증 성공
      if (payload.result == "SUCCESS") {

       const qrString = context.state.qrInfo.data;

        var qrValidation = validateQR(qrString, operGroupCd);

        if (qrValidation.step == Vue.prototype.$config.QR_VALIDATION_SUCCESS && qrValidation.isValid) {

          console.log("QR_VALIDATION_SUCCESS : STEP = " + qrValidation.step + " isValid = " + qrValidation.isValid + " qrHashMap = " + qrValidation.qrHashMap);

          if (operGroupCd.includes("VN")) {

            console.log("NAPAS QR");
            context.state.napasQrHashMap = qrValidation.qrHashMap;
            context.state.qrString = qrString;
            router.app.$router.push({ name: "napasQrPaymentStep1" });
          } else if (operGroupCd.includes("MM")) {

            console.log("MMQR");
            context.commit("setMMQRHashMap", qrValidation.qrHashMap);
            context.commit("setQRString", qrString);

            let param = {
              qrCtnt: qrString // QR원문
            };

            this._vm.$post("/transfer/mntacc/MMQRPaymentAvailable", param, response => {
              if (response.outItem.pyaccAbilYn == "1") {
                router.app.$router.push({ name: "mmQrPaymentStep1" });
              } else {
                context.commit("setError", { active: true, errType: "crcValidErr", errMsgI18n: "MPAY-07-01-01-31" }, { root: true });
              }
            });
          }
        } else {

          console.log("QR_VALIDATION_FAIL : STEP = " + qrValidation.step + " isValid = " + qrValidation.isValid + " qrHashMap = " + qrValidation.qrHashMap);

          if (operGroupCd.includes("VN")) {

            if (router.app.$route.name === "napasQrPaymentStep1") {
              router.app.$root.$children[0].$children[6].$children[1].$children[0].setCrcError();
            } else {
              context.commit("setError", { active: true, errType: "crcValidErr", errMsgI18n: "MMAIN-06-01-01-04" }, { root: true });
            }
          } else {

            var msg = qrValidation.step == Vue.prototype.$config.QR_VALIDATION_CRC ? "MPAY-07-01-01-66" : "MPAY-07-01-01-30";

            if (router.app.$route.name === "mmQrPaymentStep1") {
              router.app.$root.$children[0].$children[6].$children[1].$children[0].setCrcError(msg);
            } else {
              context.commit("setError", { active: true, errType: "crcValidErr", errMsgI18n: msg}, { root: true });
            }
          }
        }
      } else if (payload.result == "FAIL") {

        console.log("APP VALIDATION FAIL");
        context.commit("setError", { active: true, errType: "crcValidErr", errMsgI18n: (operGroupCd.includes("VN")) ? "MMAIN-06-01-01-04" : "MPAY-07-01-01-30" }, { root: true });
      } else {

        console.log("CANCEL");
      }
    },
  },
};

export default qrPaymentInpt;
